import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import EditRiskLabelConfirmMsgDialog from './edit-risk-label-confirm-dialog'
import { FormControl, InputLabel, Select, MenuItem, FormLabel, Grid } from '@material-ui/core'
import { TreeSelect } from 'antd'

const initialState = {
    input: {},
    rtp_level_list: {},
    dialogOpen: false,
    type: '',
}

class EditRiskLabelDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskLabelDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs, type) {
        const PfTree = utils.generatePfTreeData()
        this.queryData()
        this.setState({
            input: inputs,
            dialogOpen: true,
            type,
            pfSubTree: [{
                title: this.t('treeDataAll'),
                key: 'all',
                value: 'all',
                children: PfTree.filter((item) => item.key === inputs.pfId)
            }],
            pfSubPfIDList: this.props.useGameAdmin 
                ? PfTree.filter((item) => item.key === inputs.pfId)[0].children.map((item) => item.value)
                : [inputs.pfId]
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    sortRtpList(rtpList, oid, type) {
        const list = {}
        /** list需分成RTP或FeatureBuy */
        if (type === 'rtp') {
            Object.entries(rtpList[oid]).forEach(([key, value]) => {
                if (key !== 'BUYSLOTGAME') {
                    list[key] = value
                }
            })
        } else {
            list['BUYSLOTGAME'] = [...rtpList[oid].BUYSLOTGAME]
        }
        // 先把拿到的所有 rtp 降維 在排除重複的(因為這邊後端會給重複的)
        return Array.from(
            new Set(
                Object.values(list).flat()
            )
        )
    }

    queryData = () => {
        utils.apiRequest(
            'get',
            API.RISKMGT_RTP_LEVEL_LIST,
            {},
            (data) => {
                this.setState({
                    selectData: this.sortRtpList(data, this.state.input.oid, this.state.type),
                    rtp_level_list: data
                })
            },
            (_err) => { },
            true
        )
    }

    state = {
        useGameAdmin: false,
        pfSubPfIDList: [],
        pfSubPfListDisabled: false,
        pfSubTree: [],
        selectData: [],
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t(this.state.type === 'rtp' ? 'Title': 'featureTitle', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent
                    className={this.props.classes.formControl}
                >
                    {this.props.useGameAdmin && <Grid container spacing={2}>
                        <FormControl
                            style={{ marginBottom: '25px', width: '480px' }}
                            className={this.props.classes.formControl}
                            disabled={this.state.pfSubPfListDisabled}>
                            <FormLabel className={this.props.classes.shrink}>{this.t('pfSubPf')}</FormLabel>
                            <TreeSelect
                                className={this.props.classes.treeSelect}
                                treeData={this.state.pfSubTree}
                                value={this.state.pfSubPfIDList}
                                onChange={(value) => {
                                    this.setState({
                                        pfSubPfIDList: value,
                                    })
                                }}
                                disabled={this.state.pfSubPfListDisabled}
                                maxTagCount={1}
                                treeCheckable={true}
                                showSearch={true}
                                listHeight={64}
                                showCheckedStrategy={TreeSelect.SHOW_CHILD}
                                searchPlaceholder={this.t('pleaseSelect')}
                                dropdownStyle={{ zIndex: 3000 }}
                            />
                        </FormControl>
                    </Grid>}
                    <FormControl style={{ marginBottom: '10px', width: '480px' }}>
                        <InputLabel>{this.state.type === 'rtp'? this.t('rtpLabel') : this.t('featureRtpLabel')}</InputLabel>
                        <Select
                            value={this.state.input.rtp_level}
                            onChange={(event) =>
                                this.setState({
                                    input: {
                                        ...this.state.input,
                                        rtp_level: event.target.value,
                                    },
                                })
                            }>
                            {(this.state.rtp_level_list[this.state.input.oid] && this.state.selectData) &&
                                this.state.selectData.map((rtp_level) => (
                                    <MenuItem value={rtp_level} key={'rtp_level__' + rtp_level}>
                                        {rtp_level}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            const data = Object.assign(this.state.input)
                            data.pfSubPfIDList = this.state.pfSubPfIDList;
                            this.confirmDialog.OpenDialog(data, this.state.type);
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                    <EditRiskLabelConfirmMsgDialog
                        useGameAdmin={this.props.useGameAdmin}
                        onRef={(ref) => (this.confirmDialog = ref)}
                        confirmCallback={() => {
                            this.confirm();
                        }}
                    />
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1)
        },
        treeSelect: {
            width: '240px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        }
    }
}

EditRiskLabelDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    useGameAdmin: PropTypes.bool
}

export default hoc(styles)(EditRiskLabelDialog)
